export default () => {
  if (!window.IntersectionObserver) {
    return;
  }

  const topBoundary = 20;
  const stickyElements = document.querySelectorAll('[data-sticky]');

  [...stickyElements].forEach((el) => {
    const observer = new IntersectionObserver(
      (entries) => {
        let entry = entries[0];
        let classListMethod =
          entry.boundingClientRect.y < topBoundary ? 'add' : 'remove';
        entry.target.classList[classListMethod]('is-stuck');
      },
      {
        rootMargin: `-${topBoundary}px 0px 0px 0px`,
        threshold: 1,
      }
    );

    observer.observe(el);
  });
};
